module.exports = __webpack_public_path__ + "img/1297549999.1c0abdbe.jpg";